import { useCallback } from 'react';
import { useRequest } from './useRequest';
import { DashboardResponse } from '../types/dashboard';

export function useDashboard() {
  const dashboardRequest = useRequest<DashboardResponse>();

  const fetchDashboard = useCallback(async () => {
    await dashboardRequest.execute(`${process.env.REACT_APP_API_BASE_URL}/api/dashboard`);
  }, [dashboardRequest]);

  return {
    dashboard: dashboardRequest.data,
    dashboardLoading: dashboardRequest.loading,
    dashboardError: dashboardRequest.error,
    fetchDashboard,
  };
}